﻿import { Component, OnInit} from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { Router } from '@angular/router';
import { Lista } from 'src/app/_models';
import { AlertService } from 'src/app/_services';


@Component({ templateUrl: 'listas.component.html' })
export class ListasComponent implements OnInit {

    constructor(private restService: RestService, private router: Router, private alertService: AlertService) {
    }

    listas: Array<Lista>;

    ngOnInit() {
        this.loadAll();
    }


    
    private loadAll() {
        this.restService.getAll('/rest-api/user/lista').subscribe(data => {
            this.listas = data;
            if (data.length ===  1) {
                this.router.navigate(['/user/lista/' + data[0].id]);
            } else if (data.length ===  0) {
                this.alertService.info('<h3>A&uacute;n no ten&eacute;s listas</h3>Cre&aacute; tu primer lista.', true);
                this.router.navigate(['/user/crear']);
            }

        });
    }

    private link(lista: Lista): string {
        return document.location.href.toString().replace('/user/lista','/elegir?nombre=' + lista.nombre + '&codigo=' + lista.codigo);
    }
    linkWS(lista: Lista): string {
        return 'https://wa.me/?text=' + encodeURIComponent(this.link(lista));
    }

    /* To copy any Text */
    copyText(lista: Lista) {
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.link(lista);
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

}
